import { useState, useRef, useEffect } from 'react';
import { IonGrid, IonRow, IonCol, IonCheckbox, IonLabel, IonItem, IonInput, IonButton, IonIcon, useIonToast } from '@ionic/react';
import { arrowBack, arrowForward } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { CleanHTML, NumberToAlpha, TranslateAgeCode, ValidateEmail, ValidateIranMobile } from '../../../defines/Functions';
import { Constants } from '../../../defines/Constants';
import { Metrix } from '@ionic-native/metrix';
import axios from 'axios';
import TermsAndConditions from '../modals/TermsAndConditions';
import CurrencyFormat from 'react-currency-format';
import moment from 'jalali-moment';
import Loading from '../../Loading';
import './Step3.css';

interface Props {
    data: any,
    hotelRoom: any,
    rooms: any,
    activeFlight: any,
    stepParentCallback: Function,
    bookResultParentCallback: Function
}
const Step3 = (props: Props) => {
    const couponCheck = Constants.api.couponCheck;
    const flightHotelBook = Constants.api.flightHotelBook;
    const hotelRulesApi = Constants.api.hotelsRules;
    const targetName = props.data !== null && props.data.hotelDefines.targetName;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        });
    };
    const [state, setState] = useState({
        hotelRules: [] as any,
        showEmailInput: false,
        isDisabled: true
    });
    const [loading, setLoading] = useState(false);
    const [coupon, setCoupon] = useState({
        code: null as any,
        discount: null as any,
        valid: true
    });
    const [userData, setUserData] = useState({}) as any;
    const [customer, setCustomer] = useState({
        checked: false,
        email: '',
        mobile: ''
    });
    const [required, setRequired] = useState({
        email: { value: false, message: '' },
        mobile: { value: false, message: '' }
    });
    const [config, setConfig] = useState({}) as any;
    const configRef = useRef(false);
    const getConfig = async () => {
        if (!configRef.current) {
            const { value } = await Storage.get({ key: 'config' });
            if (value) {
                const objectValue = JSON.parse(value);
                setConfig(objectValue);
            } else {
                setConfig({});
            }
        }
        configRef.current = true;
    }
    getConfig();
    const userRef = useRef(false);
    const getUserData = async () => {
        if (!userRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setUserData(objectValue);
            } else {
                setUserData({});
            }
        }
        userRef.current = true;
    }
    getUserData();
    useEffect(() => {
        setLoading(true);
        let correlationID = null;
        let brandCode = null;
        let brandName = null;
        if (props.hotelRoom[0].rms.reference.id != null) {
            correlationID = props.hotelRoom[0].rms.reference.id;
        }
        if (props.hotelRoom[0].rms.reference.companyName.code != null) {
            brandCode = props.hotelRoom[0].rms.reference.companyName.code;
        }
        if (props.hotelRoom[0].rms.reference.companyName.companyShortName != null) {
            brandName = props.hotelRoom[0].rms.reference.companyName.companyShortName;
        }
        let xmlData = '<OTA_HotelBookingRuleRQ CorrelationID="' + correlationID + '">';
        xmlData += '<RuleMessage BrandCode="' + brandCode + '" BrandName="' + brandName + '" />';
        xmlData += '</OTA_HotelBookingRuleRQ>';

        axios.post(hotelRulesApi, xmlData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(function (response) {
            if (response.data.items.hasOwnProperty('errors')) {
                setState({ ...state, hotelRules: [] });
                return;
            } else {
                setState({ ...state, hotelRules: response.data.items.ruleMessage.bookingRules.bookingRule[0].description[0].text });
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error);
            setState({ ...state, hotelRules: [] });
            setLoading(false);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotelRulesApi, props.hotelRoom]);
    const toggleEmailInput = () => {
        setState({ ...state, showEmailInput: !state.showEmailInput });
    }
    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.detail.value;
        setCustomer(values => ({ ...values, [name]: value }));
    }
    const handleBlur = () => {
        if (customer.checked) {
            if (customer.email.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
            } else {
                if (!ValidateEmail(customer.email)) {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
                }
            }
            if (customer.mobile.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'الزامی' } } });
            } else {
                if (!ValidateIranMobile(customer.mobile)) {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'شماره موبایل معتبر نیست' } } });
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: false, message: '' } } });
                }
            }
        }
    }
    const onNextClick = async () => {
        let isValid = true;
        if (customer.checked) {
            if (customer.email.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'الزامی' } } });
                isValid = false;
            } else {
                if (!ValidateEmail(customer.email)) {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: true, message: 'آدرس ایمیل معتبر نیست' } } });
                    isValid = false;
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, email: { value: false, message: '' } } });
                }
            }
            if (customer.mobile.toString().trim().length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'الزامی' } } });
                isValid = false;
            } else {
                if (!ValidateIranMobile(customer.mobile)) {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: true, message: 'شماره موبایل معتبر نیست' } } });
                    isValid = false;
                } else {
                    setRequired(prevRequired => { return { ...prevRequired, mobile: { value: false, message: '' } } });
                }
            }
        }
        if (isValid) {
            let xmlData = '';
            xmlData += '<FlightHotelBookRQ>';
            xmlData += '<OTA_AirBookRQ>';
            xmlData += '<AirItinerary DirectionInd="Roundtrip">';
            let flightSegmentRph = '';
            let flightSegmentDepartureAirportTerminal = '';
            let flightSegmentArrivalAirportTerminal = '';
            let flightSegmentEquipment = '';
            let flightSegmentAircraftName = '';
            xmlData += '<OriginDestinationOptions>';
            xmlData += '<OriginDestinationOption>';
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].rph !== undefined) {
                flightSegmentRph = 'RPH="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].rph + '"';
            }
            xmlData += '<FlightSegment DepartureDateTime="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureDateTime + '" ArrivalDateTime="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].arrivalDateTime + '" StopQuantity="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].stopLocation.length + '" FlightNumber="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].flightNumber + '" ResBookDesigCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].resBookDesigCode + '" FareBasisCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].fareBasisCode + '" ' + flightSegmentRph + '>';
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureAirport.terminal !== undefined) {
                flightSegmentDepartureAirportTerminal = ' Terminal="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureAirport.terminal + '" ';
            }
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].arrivalAirport.terminal !== undefined) {
                flightSegmentArrivalAirportTerminal = ' Terminal="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].arrivalAirport.terminal + '" ';
            }
            xmlData += '<DepartureAirport LocationCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].departureAirport.locationCode + '" ' + flightSegmentDepartureAirportTerminal + '/>';
            xmlData += '<ArrivalAirport LocationCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].arrivalAirport.locationCode + '" ' + flightSegmentArrivalAirportTerminal + '/>';
            xmlData += '<OperatingAirline Code="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].operatingAirline.code + '"/>';
            xmlData += '<MarketingAirline Code="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].marketingAirline.code + '"/>';
            if (
                props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].equipment !== undefined &&
                props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].equipment[0] !== undefined
            ) {
                if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].equipment[0].airEquipType !== undefined) {
                    flightSegmentEquipment = '<Equipment AirEquipType="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].equipment[0].airEquipType + '"/>';
                }
            }
            xmlData += flightSegmentEquipment;
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions !== undefined) {
                flightSegmentAircraftName = '<aircraftName>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].aircraftName + '</aircraftName>';
            }
            xmlData += flightSegmentAircraftName;
            xmlData += '<freeBaggage>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].freeBaggage + '</freeBaggage>';
            xmlData += '<departureAirport>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].departureAirport + '</departureAirport>';
            xmlData += '<departureCountry>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].departureCountry + '</departureCountry>';
            xmlData += '<departureCity>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].departureCity + '</departureCity>';
            xmlData += '<arrivalCity>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].arrivalCity + '</arrivalCity>';
            xmlData += '<arrivalAirport>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].arrivalAirport + '</arrivalAirport>';
            xmlData += '<arrivalCountry>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[0].tpaextensions.any[0].arrivalCountry + '</arrivalCountry>';
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '</FlightSegment>';
            xmlData += '</OriginDestinationOption>';
            flightSegmentRph = '';
            flightSegmentDepartureAirportTerminal = '';
            flightSegmentArrivalAirportTerminal = '';
            flightSegmentEquipment = '';
            flightSegmentAircraftName = '';
            xmlData += '<OriginDestinationOption>';
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].rph !== undefined) {
                flightSegmentRph = 'RPH="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].rph + '"';
            }
            xmlData += '<FlightSegment DepartureDateTime="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureDateTime + '" ArrivalDateTime="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].arrivalDateTime + '" StopQuantity="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].stopLocation.length + '" FlightNumber="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].flightNumber + '" ResBookDesigCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].resBookDesigCode + '" FareBasisCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].fareBasisCode + '" ' + flightSegmentRph + '>';
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureAirport.terminal !== undefined) {
                flightSegmentDepartureAirportTerminal = ' Terminal="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureAirport.terminal + '" ';
            }
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].arrivalAirport.terminal !== undefined) {
                flightSegmentArrivalAirportTerminal = ' Terminal="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].arrivalAirport.terminal + '" ';
            }
            xmlData += '<DepartureAirport LocationCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].departureAirport.locationCode + '" ' + flightSegmentDepartureAirportTerminal + '/>';
            xmlData += '<ArrivalAirport LocationCode="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].arrivalAirport.locationCode + '" ' + flightSegmentArrivalAirportTerminal + '/>';
            xmlData += '<OperatingAirline Code="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].operatingAirline.code + '"/>';
            xmlData += '<MarketingAirline Code="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].marketingAirline.code + '"/>';
            if (
                props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].equipment !== undefined &&
                props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].equipment[0] !== undefined
            ) {
                if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].equipment[0].airEquipType !== undefined) {
                    flightSegmentEquipment = '<Equipment AirEquipType="' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].equipment[0].airEquipType + '"/>';
                }
            }
            xmlData += flightSegmentEquipment;
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            if (props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions !== undefined) {
                flightSegmentAircraftName = '<aircraftName>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].aircraftName + '</aircraftName>';
            }
            xmlData += flightSegmentAircraftName;
            xmlData += '<freeBaggage>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].freeBaggage + '</freeBaggage>';
            xmlData += '<departureAirport>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].departureAirport + '</departureAirport>';
            xmlData += '<departureCountry>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].departureCountry + '</departureCountry>';
            xmlData += '<departureCity>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].departureCity + '</departureCity>';
            xmlData += '<arrivalCity>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].arrivalCity + '</arrivalCity>';
            xmlData += '<arrivalAirport>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].arrivalAirport + '</arrivalAirport>';
            xmlData += '<arrivalCountry>' + props.activeFlight.airItinerary.originDestinationOptions.originDestinationOption[1].flightSegment[0].tpaextensions.any[0].arrivalCountry + '</arrivalCountry>';
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '</FlightSegment>';
            xmlData += '</OriginDestinationOption>';
            xmlData += '</OriginDestinationOptions>';
            xmlData += '</AirItinerary>';
            xmlData += '<PriceInfo ValidatingAirlineCode="' + props.activeFlight.airItineraryPricingInfo.validatingAirlineCode + '">';
            xmlData += '<ItinTotalFare>';
            xmlData += '<BaseFare CurrencyCode="' + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].baseFare.currencyCode + '" Amount="' + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].baseFare.amount + '"/>';
            xmlData += '<TotalFare CurrencyCode="' + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].totalFare.currencyCode + '" Amount="' + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].totalFare.amount + '"/>';
            xmlData += '</ItinTotalFare>';
            xmlData += '</PriceInfo>';
            xmlData += '<TravelerInfo>';
            props.rooms.forEach((room: any) => {
                room.forEach((passenger: any) => {
                    xmlData += '<AirTraveler BirthDate="' + passenger.birth_date.value + '" PassengerTypeCode="' + passenger.type.value + '" Gender="' + passenger.gender.value.toUpperCase() + '">';
                    xmlData += '<PersonName>';
                    xmlData += '<NamePrefix>' + (passenger.gender.value === 'm' ? 'MR' : 'MRS') + '</NamePrefix>';
                    xmlData += '<GivenName>' + passenger.first_name.value + '</GivenName>';
                    xmlData += '<Surname>' + passenger.last_name.value + '</Surname>';
                    xmlData += '</PersonName>';
                    xmlData += '<Telephone PhoneNumber="' + (customer.mobile ? customer.mobile : userData.mobile_no) + '"/>';
                    xmlData += '<Email>' + (customer.email ? customer.email : userData.email) + '</Email>';
                    if (props.data.hotelDefines.targetName !== 'International') {
                        xmlData += '<Document DocID="' + passenger.national_code.value + '" DocType="5" DocHolderNationality="' + passenger.nationality.value.iso + '" />';
                    } else {
                        xmlData += '<Document DocID="' + passenger.passport_code.value + '" DocType="2" DocIssueCountry="' + passenger.nationality.value.iso + '" DocHolderNationality="' + passenger.nationality.value.iso + '" ExpireDate="' + passenger.passport_exp_date.value + '"/>';
                    }
                    xmlData += '</AirTraveler>';
                })
            })
            xmlData += '</TravelerInfo>';
            xmlData += '<Fulfillment>';
            xmlData += '<Name>';
            xmlData += '<GivenName>' + userData.first_name + '</GivenName>';
            xmlData += '<Surname>' + userData.last_name + '</Surname>';
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            xmlData += '<Username>' + (customer.email ? customer.email : userData.email) + '</Username>';
            xmlData += '<Country>' + userData.nationality + '</Country>';
            xmlData += '<PersianLastName>' + userData.last_name + '</PersianLastName>';
            xmlData += '<Gender>' + (userData.gender && userData.gender === 'f' ? 'Female' : 'Male') + '</Gender>';
            xmlData += '<City>' + (userData.city ? userData.city : userData.city) + '</City>';
            xmlData += '<PersianFirstName>' + userData.first_name + '</PersianFirstName>';
            xmlData += '<Mobile>' + (customer.mobile ? customer.mobile : userData.mobile_no) + '</Mobile>';
            xmlData += '<Nationality>' + userData.nationality + '</Nationality>';
            xmlData += '<NationalityNum>' + userData.national_code + '</NationalityNum>';
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '</Name>';
            xmlData += '</Fulfillment>';
            xmlData += '<Ticketing>';
            xmlData += '<TicketingVendor CompanyShortName="' + props.activeFlight.ticketingInfo.ticketingVendor.companyShortName + '" Code="' + props.activeFlight.ticketingInfo.ticketingVendor.code + '" CodeContext="' + props.activeFlight.ticketingInfo.ticketingVendor.codeContext + '" />';
            xmlData += '</Ticketing>';
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            xmlData += '<callbackUrl>' + Constants.paymentCallback.flightHotel + '</callbackUrl>';
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '</OTA_AirBookRQ>';
            xmlData += '<OTA_HotelResRQ>';
            xmlData += '<UniqueID Type="' + props.hotelRoom[0].rms.reference.type + '" ID="' + props.hotelRoom[0].rms.reference.id + '">';
            xmlData += '<CompanyName CompanyShortName="' + props.hotelRoom[0].rms.reference.companyName.companyShortName + '" Code="' + props.hotelRoom[0].rms.reference.companyName.code + '"/>';
            xmlData += '</UniqueID>';
            xmlData += '<HotelReservations>';
            xmlData += '<HotelReservation>';
            xmlData += '<RoomStays>';
            let valueCount = 0;
            props.rooms.forEach((room: any) => {
                let adultCount = 0;
                room.forEach((passengerInfo: any) => {
                    if (passengerInfo.type.value === 'ADT') {
                        adultCount++;
                    }
                })
                xmlData += '<RoomStay>';
                xmlData += '<ResGuestRPHs>';
                room.forEach(() => {
                    valueCount++;
                    xmlData += '<value>' + valueCount + '</value>';
                })
                xmlData += '</ResGuestRPHs>';
                xmlData += '<RoomTypes>';
                xmlData += '<HotelRoomType RoomID="' + props.hotelRoom[0].rms.roomRates.roomRate[0].roomID + '" RoomTypeCode="' + props.hotelRoom[0].rms.roomTypes.roomType[0].roomTypeCode + '" HotelRoomType="' + props.hotelRoom[0].rms.roomTypes.roomType[0].roomType + '"/>';
                xmlData += '</RoomTypes>';
                xmlData += '<RoomRates>';
                xmlData += '<RoomRate RoomID="' + props.hotelRoom[0].rms.roomRates.roomRate[0].roomID + '" RatePlanID="' + props.hotelRoom[0].rms.roomRates.roomRate[0].ratePlanID + '">';
                xmlData += '<GuestCounts>';
                xmlData += '<GuestCount AgeQualifyingCode="Adult" Count="' + adultCount + '"/>';
                room.forEach((passengerInfo: any) => {
                    if (passengerInfo.type.value === 'CHD') {
                        xmlData += '<GuestCount AgeQualifyingCode="Child" Count="1" Age="' + passengerInfo.age.value + '"/>';
                    }
                })
                xmlData += '</GuestCounts>';
                xmlData += '</RoomRate>';
                xmlData += '</RoomRates>';
                xmlData += '</RoomStay>';
            })
            xmlData += '</RoomStays>';
            xmlData += '<ResGuests>';
            let k = 0;
            props.rooms.forEach((room: any) => {
                room.forEach((passengerInfo: any) => {
                    k++;
                    let AgeQualifyingAge = '';
                    if (passengerInfo.type.value === 'CHD') {
                        AgeQualifyingAge = 'Age="' + passengerInfo.age.value + '"';
                    }
                    xmlData += '<ResGuest ResGuestRPH="' + k + '" AgeQualifyingCode="' + (passengerInfo.type.value === 'ADT' ? 'Adult' : 'Child') + '" ' + AgeQualifyingAge + '>';
                    xmlData += '<Profiles>';
                    xmlData += '<ProfileInfo>';
                    xmlData += '<Profile>';
                    xmlData += '<Customer BirthDate="' + passengerInfo.birth_date.value + '" Gender="' + passengerInfo.gender.value.toUpperCase() + '">';
                    xmlData += '<PersonName>';
                    xmlData += '<NamePrefix>' + (passengerInfo.gender.value === 'm' ? 'MR' : 'MRS') + '</NamePrefix>';
                    xmlData += '<GivenName>' + passengerInfo.first_name.value + '</GivenName>';
                    xmlData += '<Surname>' + passengerInfo.last_name.value + '</Surname>';
                    xmlData += '</PersonName>';
                    xmlData += '<Email>noreply@connectota.com</Email>';
                    xmlData += '<Address>';
                    xmlData += '<County>' + passengerInfo.nationality.value.iso + '</County>';
                    xmlData += '</Address>';
                    if (!passengerInfo.toggle.value) {
                        xmlData += '<Document DocID="' + passengerInfo.national_code.value + '" DocType="5" DocHolderNationality="' + passengerInfo.nationality.value.iso + '" />';
                    } else {
                        xmlData += '<Document DocID="' + passengerInfo.passport_code.value + '" DocType="2" DocIssueCountry="' + passengerInfo.nationality.value.iso + '" DocHolderNationality="' + passengerInfo.nationality.value.iso + '" />';
                    }
                    xmlData += '</Customer>';
                    xmlData += '</Profile>';
                    xmlData += '</ProfileInfo>';
                    xmlData += '</Profiles>';
                    xmlData += '</ResGuest>';
                })
            })
            xmlData += '</ResGuests>';
            if (coupon.code && coupon.code !== null) {
                xmlData += '<Memberships>';
                xmlData += '<Membership BonusCode="' + coupon.code + '" />';
                xmlData += '</Memberships>';
            }
            xmlData += '<ResGlobalInfo>';
            xmlData += '<TimeSpan Start="' + props.data.hotelDefines.all.dates.departure + '" End="' + props.data.hotelDefines.all.dates.arrival + '" />';
            xmlData += '<BasicPropertyInfo HotelCode="' + props.data.data.basicPropertyInfo.hotelCode + '" HotelName="' + props.data.data.basicPropertyInfo.hotelName + '"/>';
            xmlData += '<Total AmountAfterTax="' + props.hotelRoom[0].rms.total.amountAfterTax + '" CurrencyCode="' + props.hotelRoom[0].rms.total.currencyCode + '"/>';
            xmlData += '<Profiles>';
            xmlData += '<ProfileInfo>';
            xmlData += '<Profile>';
            xmlData += '<Customer BirthDate="' + userData.birth_date + '" Gender="' + (userData.gender === 'm' ? 'Male' : 'Female') + '">';
            xmlData += '<PersonName>';
            xmlData += '<NamePrefix>' + (userData.gender === 'm' ? 'MR' : 'MRS') + '</NamePrefix>';
            xmlData += '<GivenName>' + userData.first_name + '</GivenName>';
            xmlData += '<Surname>' + userData.last_name + '</Surname>';
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            xmlData += '<Username>' + (customer.email ? customer.email : userData.email) + '</Username>';
            xmlData += '<Gender>' + (userData.gender === 'm' ? 'Male' : 'Female') + '</Gender>';
            xmlData += '<Nationality>' + userData.nationality + '</Nationality>';
            xmlData += '<NationalityNum>' + (userData.doc_type === 'm' ? userData.national_code : userData.passport_code) + '</NationalityNum>';
            xmlData += '<PersianFirstName>' + userData.first_name + '</PersianFirstName>';
            xmlData += '<PersianLastName>' + userData.last_name + '</PersianLastName>';
            xmlData += '<Mobile>' + (customer.mobile ? customer.mobile : userData.mobile_no) + '</Mobile>';
            xmlData += '<Country>' + userData.nationality + '</Country>';
            xmlData += '<City>' + userData.city + '</City>';
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '</PersonName>';
            xmlData += '</Customer>';
            xmlData += '</Profile>';
            xmlData += '</ProfileInfo>';
            xmlData += '</Profiles>';
            xmlData += '</ResGlobalInfo>';
            xmlData += '</HotelReservation>';
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            xmlData += '<callbackUrl>' + Constants.paymentCallback.flightHotel + '</callbackUrl>';
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '</HotelReservations>';
            xmlData += '</OTA_HotelResRQ>';
            xmlData += '<TPA_Extensions>';
            xmlData += '<TPA_Extension>';
            xmlData += '<callbackUrl>' + Constants.paymentCallback.flightHotel + '</callbackUrl>';
            if (coupon.code && coupon.code !== null) {
                xmlData += '<DiscountCode>' + coupon.code + '</DiscountCode>';
            } else {
                xmlData += '<DiscountCode></DiscountCode>';
            }
            xmlData += '</TPA_Extension>';
            xmlData += '</TPA_Extensions>';
            xmlData += '<TravelServiceResRequest></TravelServiceResRequest>';
            xmlData += '</FlightHotelBookRQ>';
            try {
                setLoading(true);
                const bookResults = await axios.post(flightHotelBook + '?target_name=' + targetName, xmlData, {
                    headers: {
                        Authorization: 'Bearer ' + userData.token,
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                if (bookResults.data.status === 'error') {
                    showToast({ message: bookResults.data.message, color: 'danger' });
                    setLoading(false);
                } else {
                    Metrix.newEvent("mpmmk");
                    setLoading(false);
                    props.bookResultParentCallback(bookResults.data.items);
                    props.stepParentCallback(4);
                }
            } catch (error: any) {
                console.log(error);
                showToast({ message: error.response.data.message, color: 'danger' });
                setLoading(false);
            }
        }
    }
    const onPrevClick = () => {
        props.stepParentCallback(2);
    }
    const handleSubmit = (event: any) => {
        let isRequired = false;
        event.preventDefault();
        if (coupon.code === null) {
            setCoupon({ ...coupon, valid: false });
            isRequired = true;
        } else {
            setCoupon({ ...coupon, valid: true });
            isRequired = false;
        }
        if (!isRequired) {
            submitCoupon();
        }
    }
    const submitCoupon = async () => {
        console.log(props)
        setLoading(true);
        const xmlData = '<UserDiscountCode><code>' + coupon.code + '</code><requestType>FLIGHT</requestType></UserDiscountCode>';
        try {
            const results = await axios.post(couponCheck, xmlData, {
                headers: {
                    Authorization: 'Bearer ' + userData.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (results.data.status === 'error') {
                setCoupon({ code: null, discount: null, valid: false });
                showToast({ message: results.data.message, color: 'danger' });
                setLoading(false);
            } else {
                let response = results.data.items.result;
                let discountAmount = 0;
                let payAmount = (props.hotelRoom[0].rms.total.amountBeforeTax + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].baseFare.amount);
                if (response.usedCount >= response.maxCount) {
                    showToast({ message: 'کد تخفیف وارد شده نا معتبر است', color: 'danger' });
                } else {
                    if (payAmount > response.minAmount) {
                        if (response.modificationType === "PERCENT") {
                            discountAmount = payAmount * (response.discount * 100) / 100;
                        } else {
                            discountAmount = response.discount;
                        }
                        setCoupon({ code: response.code, discount: discountAmount, valid: true })
                        showToast({ message: results.data.message, color: 'success' });
                    } else {
                        showToast({ message: 'کد تخفیف وارد شده نا معتبر است', color: 'danger' });
                    }
                }
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
            showToast({ message: error.response.data.message, color: 'danger' });
            setLoading(false);
        }
    }
    const removeCoupon = () => {
        setCoupon({ code: null, discount: null, valid: false })
    }
    return (
        <div className="flight-hotel-reservation-step3">
            {!loading ?
                <>
                    {targetName === 'International' ?
                        <div className="step3-description box">
                            {CleanHTML(config.tour_reservation_international_hint)}
                        </div>
                        :
                        <div className="step3-description box">
                            {CleanHTML(config.tour_reservation_domestic_hint)}
                        </div>
                    }
                    {props.rooms.map((room: any, roomIndex: number) =>
                        <div className="step3-passenger-info box" key={"index" + roomIndex}>
                            {room.map((item: any, index: number) =>
                                <div key={"index" + index}>
                                    {index === 0 &&
                                        <h5>
                                            <span className="room-count-title">
                                                اتاق {NumberToAlpha(roomIndex + 1)}
                                            </span>
                                        </h5>
                                    }
                                    <h5>
                                        اطلاعات مسافر {NumberToAlpha(index + 1)} - {TranslateAgeCode(item.type.value)}
                                    </h5>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size="12">
                                                <span>جنسیت :</span>
                                                <b>{item.gender.value === 'f' ? 'خانم' : 'آقا'}</b>
                                            </IonCol>
                                            <IonCol size="12">
                                                <span>نام :</span>
                                                <b>{item.first_name.value}</b>
                                            </IonCol>
                                            <IonCol size="12">
                                                <span>نام خانوادگی :</span>
                                                <b>{item.last_name.value}</b>
                                            </IonCol>
                                            <IonCol size="12">
                                                <span>تاریخ تولد :</span>
                                                <b>{moment(item.birth_date.value).format('YYYY/MM/DD')}</b>
                                            </IonCol>
                                            {!item.toggle.value ?
                                                <IonCol size="12">
                                                    <span>کد ملی :</span>
                                                    <b>{item.national_code.value}</b>
                                                </IonCol>
                                                :
                                                <>
                                                    <IonCol size="12">
                                                        <span>ملیت :</span>
                                                        <b>{item.nationality.value.name}</b>
                                                    </IonCol>

                                                    <IonCol size="12">
                                                        <span>شماره پاسپورت :</span>
                                                        <b>{item.passport_code.value}</b>
                                                    </IonCol>
                                                    <IonCol size="12">
                                                        <span>تاریخ انقضای پاسپورت :</span>
                                                        <b>{moment(item.passport_exp_date.value).format('YYYY/MM/DD')}</b>
                                                    </IonCol>
                                                </>
                                            }
                                        </IonRow>
                                    </IonGrid>
                                </div>
                            )}
                        </div>
                    )}
                    <div className={targetName === 'International' ? 'hotel-rules box my-ltr' : 'hotel-rules box'}>
                        <h5>قوانین و مقررات هتل</h5>
                        <div dangerouslySetInnerHTML={{ __html: state.hotelRules }}></div>
                    </div>
                    <div className="step3-total-price box">
                        <h5>
                            مجموع قیمت ها
                        </h5>
                        <IonGrid>
                            <IonRow>
                                <IonCol size="6">
                                    <span>مبلغ قابل پرداخت</span>
                                </IonCol>
                                <IonCol size="6" className="ion-text-left">
                                    <span className="total-pay">
                                        <CurrencyFormat value={props.data.data.price[0].amountAfterTax + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                    </span>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </div>
                    <div className="step3-checkbox box">
                        <IonItem lines="none" onClick={toggleEmailInput}>
                            <IonCheckbox color="warning" checked={customer.checked} onIonChange={e => setCustomer({ ...customer, checked: e.detail.checked })} />
                            <IonLabel className="ion-text-wrap">
                                می خواهم بلیط به ایمیل یا شماره همراه فرد دیگری ارسال شود.
                            </IonLabel>
                        </IonItem>
                        <div className={state.showEmailInput ? '' : 'display-none'}>
                            <IonLabel>
                                آدرس ایمیل
                                {required.email.value ? <span className="required">{required.email.message}</span> : null}
                            </IonLabel>
                            <IonInput type="email" value={customer.email || ''} onIonChange={handleChange} onIonBlur={handleBlur} className="ion-margin-bottom" />
                            <IonLabel>
                                شماره موبایل
                                {required.mobile.value ? <span className="required">{required.mobile.message}</span> : null}
                            </IonLabel>
                            <IonInput type="tel" value={customer.mobile || ''} onIonChange={handleChange} onIonBlur={handleBlur} />
                        </div>
                    </div>
                    <div className="step3-coupon box">
                        <h5>
                            کد تخفیف دارید؟ وارد کنید :
                            {!coupon.valid ? <span className="required">الزامی</span> : null}
                        </h5>
                        <IonInput type="text" name="coupon" value={coupon.code || ''} onIonChange={(e: any) => setCoupon({ ...coupon, code: e.target.value })} />
                        {coupon.discount === null ?
                            <IonButton color="primary" expand="block" className="ion-margin-top" onClick={handleSubmit}>
                                بررسی کد تخفیف
                            </IonButton>
                            :
                            <IonButton color="danger" expand="block" className="ion-margin-top" onClick={removeCoupon}>
                                حذف کد تخفیف
                            </IonButton>
                        }
                    </div>
                    <div className="step3-terms">
                        <IonCheckbox color="warning" onIonChange={() => setState({ ...state, isDisabled: !state.isDisabled })} />
                        <IonLabel className="ion-text-wrap">
                            صحت موارد فوق را تایید میکنم،
                            <TermsAndConditions />
                            را مطالعه نمودم و با موارد آن موافقم.
                        </IonLabel>
                    </div>
                    <div className="step-btns">
                        <IonButton color="warning" onClick={onPrevClick}>
                            <IonIcon icon={arrowForward} />
                            مرحله قبل
                        </IonButton>
                        <IonButton color="primary" onClick={onNextClick} disabled={state.isDisabled}>
                            تایید اطلاعات و پرداخت
                            <IonIcon icon={arrowBack} />
                        </IonButton>
                    </div>
                </>
                :
                <Loading />
            }
        </div>
    );
};
export default Step3;